// extracted by mini-css-extract-plugin
export var page_header = "page-header-module--page_header--zn4dl";
export var pageHeaderFadeInSlidePc = "page-header-module--pageHeader-fadeInSlide-pc--K5WXf";
export var pageHeaderFadeInSlideSp = "page-header-module--pageHeader-fadeInSlide-sp--3NvFg";
export var page_header__title = "page-header-module--page_header__title--18qfj";
export var page_header__head_text = "page-header-module--page_header__head_text--2Ib79";
export var page_header__text = "page-header-module--page_header__text--8TbqV";
export var page_header__lead = "page-header-module--page_header__lead--2q1V1";